import { render, staticRenderFns } from "./CartBadge.vue?vue&type=template&id=87210fa8&"
import script from "./CartBadge.vue?vue&type=script&lang=js&"
export * from "./CartBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports